import { CameraIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import {
    useGetScreenshotAttemptsByContentIdQuery,
    ScreenshotAttempt
} from '../../api/client'
import Button from '../Button'
import Modal from '../Modal'
import ScreenshotAttemptList from './ScreenshotAttemptList'
import ScreenshotDetailsModal from './ScreenshotDetailsModal'
import ScreenshotImageModal from './ScreenshotImageModal'

type Props = {
    open: boolean
    setOpen: (open: boolean) => void
    contentId: number | null
    contentText?: string | null
}

export default function ContentAttemptsModal({ open, setOpen, contentId, contentText }: Props) {
    const [selectedScreenshot, setSelectedScreenshot] = useState<ScreenshotAttempt | null>(null)
    const [detailsModalOpen, setDetailsModalOpen] = useState(false)
    const [imageModalOpen, setImageModalOpen] = useState(false)

    const { data, loading, error } = useGetScreenshotAttemptsByContentIdQuery({
        variables: { contentId: contentId! },
        skip: !contentId || !open
    })

    const attempts = data?.getScreenshotAttemptsByContentId || []

    if (!contentId) return null

    return (
        <>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title={`All attempts for content #${contentId}`}
                description={
                    contentText && <div className="truncate max-w-lg">{contentText}</div>
                }
                icon={<CameraIcon className="h-8 w-8 text-ink-700" aria-hidden="true" />}
                size="2xl"
                footer={<Button text="Close" primary={false} onClick={() => setOpen(false)} />}
            >
                <div className="max-h-[60vh] overflow-y-auto">
                    <ScreenshotAttemptList
                        attempts={attempts}
                        loading={loading}
                        error={error}
                        onViewImage={(attempt) => {
                            setSelectedScreenshot(attempt)
                            setImageModalOpen(true)
                        }}
                        onViewLogs={(attempt) => {
                            setSelectedScreenshot(attempt)
                            setDetailsModalOpen(true)
                        }}
                    />
                </div>
            </Modal>

            {/* Nested modals */}
            <ScreenshotDetailsModal
                open={detailsModalOpen}
                setOpen={setDetailsModalOpen}
                screenshot={selectedScreenshot}
            />
            <ScreenshotImageModal
                open={imageModalOpen}
                setOpen={setImageModalOpen}
                imageUrl={selectedScreenshot?.s3Url || null}
                contentId={contentId}
            />
        </>
    )
}
